import { db } from '../firebase/config';
import { collection, addDoc, getDocs, doc, setDoc, deleteDoc } from 'firebase/firestore';

const runTest = async () => {
  const results = {
    connectionSuccess: false,
    readSuccess: false,
    writeSuccess: false,
    deleteSuccess: false,
    errors: []
  };

  try {
    console.log('=== FIREBASE CONNECTION TEST ===');
    console.log('Testing Firestore connection...');

    // Test collection name
    const testCollectionName = 'firebase_test';

    // Step 1: Test writing to Firestore
    try {
      console.log('Testing write operation...');
      const testDoc = {
        timestamp: new Date().toISOString(),
        message: 'Test document for Nail the Cost website'
      };

      const docRef = await addDoc(collection(db, testCollectionName), testDoc);
      console.log(`✅ Write successful. Document ID: ${docRef.id}`);
      results.writeSuccess = true;
      results.testDocId = docRef.id;
    } catch (error) {
      console.error('❌ Write test failed:', error);
      results.errors.push({
        operation: 'write',
        message: error.message,
        code: error.code
      });
    }

    // Step 2: Test reading from Firestore
    try {
      console.log('Testing read operation...');
      const querySnapshot = await getDocs(collection(db, testCollectionName));
      
      console.log(`✅ Read successful. Found ${querySnapshot.docs.length} documents.`);
      querySnapshot.forEach(doc => {
        console.log(`Document ID: ${doc.id}, Data:`, doc.data());
      });
      
      results.readSuccess = true;
      results.docsFound = querySnapshot.docs.length;
    } catch (error) {
      console.error('❌ Read test failed:', error);
      results.errors.push({
        operation: 'read',
        message: error.message,
        code: error.code
      });
    }

    // Step 3: Test deleting from Firestore (cleanup)
    if (results.testDocId) {
      try {
        console.log('Testing delete operation (cleanup)...');
        await deleteDoc(doc(db, testCollectionName, results.testDocId));
        console.log(`✅ Delete successful. Removed test document.`);
        results.deleteSuccess = true;
      } catch (error) {
        console.error('❌ Delete test failed:', error);
        results.errors.push({
          operation: 'delete',
          message: error.message,
          code: error.code
        });
      }
    }

    // Overall result
    results.connectionSuccess = results.readSuccess || results.writeSuccess;
    
    console.log('=== TEST SUMMARY ===');
    console.log(`Connection: ${results.connectionSuccess ? '✅ SUCCESS' : '❌ FAILED'}`);
    console.log(`Read: ${results.readSuccess ? '✅ SUCCESS' : '❌ FAILED'}`);
    console.log(`Write: ${results.writeSuccess ? '✅ SUCCESS' : '❌ FAILED'}`);
    console.log(`Delete: ${results.deleteSuccess ? '✅ SUCCESS' : '❌ FAILED'}`);
    
    if (results.errors.length > 0) {
      console.log('=== ERRORS ===');
      results.errors.forEach((error, i) => {
        console.log(`Error ${i+1}: [${error.operation}] ${error.message}`);
      });
    }
    
    // Provide helpful tips based on errors
    if (!results.connectionSuccess) {
      console.log('\n=== TROUBLESHOOTING TIPS ===');
      console.log('1. Check if your Firebase API key and project ID are correct');
      console.log('2. Ensure you have created a Firestore database in your Firebase project');
      console.log('3. Make sure your Firebase project has Firestore enabled');
    } else if (!results.writeSuccess) {
      console.log('\n=== TROUBLESHOOTING TIPS ===');
      console.log('1. Check your Firestore security rules');
      console.log('2. Try setting your database to test mode temporarily');
      console.log('3. Make sure your Firebase project permissions are correctly set');
    }

    return results;
  } catch (error) {
    console.error('Test failed with unexpected error:', error);
    results.errors.push({
      operation: 'connection',
      message: error.message,
      code: error.code
    });
    return results;
  }
};

export default runTest; 